/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Status_ActiveInputs */



/**
* | output |
* | --- |
* | "Active" |
*
* @param {Team_Manager_Status_ActiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_status_active = /** @type {((inputs?: Team_Manager_Status_ActiveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Status_ActiveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actif")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktiv")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Активен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活跃")
	if (locale === "ja") return /** @type {LocalizedString} */ ("有効")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सक्रिय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativo")
	return /** @type {LocalizedString} */ ("Active")
});